import React from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { NumericFormat } from "react-number-format";

//Strings
import { Strings } from "../../resources/i18n/i18n";

//Constants
import { OPERATION_STATUS } from "../../config/axios.init";

//Components
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";

//Action
import { applyExternalReconciliationAction } from "./AnalystApprovalAction";

class ExternalReconciliationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reconciledAmount: "",
      description: "",
      errorMessage: "",
      loading: false,
    };
  }

  onApply = () => {
    // Debounce: ignore further clicks while a request is in-flight.
    if (this.state.loading) {
      return;
    }
    if (
      !this.state.reconciledAmount ||
      Number(this.state.reconciledAmount) <= 0
    ) {
      this.setState({ errorMessage: Strings("reconciledAmountError") });
      return;
    }
    if (!this.state.description || this.state.description.trim().length === 0) {
      this.setState({ errorMessage: Strings("pleaseEnterNote") });
      return;
    }
    const request = {
      aid: this.props.applicationId,
      reconAmt: Number(this.state.reconciledAmount),
      reconDesc: this.state.description.trim(),
    };
    this.setState({ loading: true, errorMessage: "" });
    applyExternalReconciliationAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({ loading: false });
        this.props.onApplied(Strings("externalReconciliationSuccess"));
      } else {
        this.setState({ loading: false, errorMessage: response.error.message });
      }
    });
  };

  render() {
    return (
      <div className='notesModal'>
        <LoadingModal showLoadingModal={this.state.loading} />
        <Modal
          open={this.props.open}
          onClose={this.props.toggleModal}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          classNames={{ modal: "customModal" }}
          showCloseIcon={false}
          center
        >
          <Row className='notesModal'>
            <Col md={12} className='headerModal'>
              {Strings("applyExternalReconciliation")}
            </Col>
            <Col md={12} className='modalContent'>
              {this.state.errorMessage && (
                <Row style={{ textAlign: "center" }} className='errors'>
                  {this.state.errorMessage}
                </Row>
              )}
              <Row className='py-2'>
                <Col md={12}>
                  {Strings("reconciledAmount")}{" "}
                  <span className='mandatoryFields'>*</span>
                </Col>
                <Col md={12}>
                  <NumericFormat
                    name='reconciledAmount'
                    className='form-control w-100'
                    onValueChange={(event) =>
                      this.setState({
                        reconciledAmount: event.value,
                        errorMessage: "",
                      })
                    }
                    value={this.state.reconciledAmount}
                    thousandSeparator={true}
                    prefix={"$"}
                    decimalScale={2}
                    allowNegative={false}
                    placeholder={Strings("reconciledAmount")}
                  />
                </Col>
              </Row>
              <Row className='userInput'>
                <Col md={12}>
                  {Strings("reconciledDescription")}{" "}
                  <span className='mandatoryFields'>*</span>
                </Col>
                <Col md={12}>
                  <div className='inputFields'>
                    <textarea
                      className='w-100'
                      id='reconDesc'
                      placeholder={Strings(
                        "reconciliationDescriptionPlaceholder"
                      )}
                      maxLength={1000}
                      value={this.state.description}
                      cols={45}
                      rows={4}
                      onChange={(event) =>
                        this.setState({
                          description: event.target.value,
                          errorMessage: "",
                        })
                      }
                    />
                  </div>
                </Col>
              </Row>
              <hr className='Noteshr opacity-100' />
              <Row className='modalButton'>
                <Col md={12}>
                  <Button
                    className='buttonBackground primaryModalButton buttonMinWidth'
                    onClick={this.onApply}
                    disabled={this.state.loading}
                  >
                    {Strings("Submit")}
                  </Button>
                  <Button
                    className='primaryModalButton buttonMinWidth marginCancelButton buttonBorder'
                    onClick={this.props.toggleModal}
                    disabled={this.state.loading}
                  >
                    {Strings("Cancel")}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default ExternalReconciliationModal;
